import { Component, inject } from '@angular/core';
import { BreadcrumbComponent } from '../shared/breadcrumb/breadcrumb.component';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ErrorCategoryTabsComponent } from './shared/error-category-tabs/error-category-tabs.component';
import { BehaviorSubject, combineLatest, filter, map } from 'rxjs';
import { UserService } from 'app/services/user/user.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ScopeContextFilterComponent } from "../shared/scope-context-filter/scope-context-filter.component";
import { SelectedData } from '../shared/scope-context-filter/scope-context-filter.model';
import { LoggingService } from '@tdoe/design-system';
import dayjs from 'dayjs';
import { CacheService } from 'app/services/cache-service/cache.service';

@Component({
  selector: 'app-error-log',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    ErrorCategoryTabsComponent,
    RouterOutlet,
    CommonModule,
    ScopeContextFilterComponent,
    ErrorCategoryTabsComponent
],
  templateUrl: './error-log.component.html',
  styleUrl: './error-log.component.scss'
})
export class ErrorLogComponent {

  private readonly router = inject(Router);
  private readonly logger = inject(LoggingService);
  private readonly cacheService = inject(CacheService);

  protected onErrorCategoryTabSelected(tabName: string): void { 
    this.router.navigate([`/error-log/${tabName}`]);
  }

  protected onSearchClicked(selectedData: SelectedData): void {
    if (!Array.isArray(selectedData.years)) {
      selectedData.years = [selectedData.years];
    }
    this.cacheService.selectedData$.next(selectedData);
    this.logger.debug('ErrorLogComponent -> onSearchClicked', {
      data: {
        selectedData
      }
    });
  }

  public onResetQuery(): void {
    this.cacheService.selectedData$.next({ years: [this.cacheService.selectedSchoolYear()] });
  }

}
